var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "d-flex justify-content-right profile-maindv"
  }, [_c('div', {
    staticClass: "profile-img"
  }, [_vm.profileImage ? _c('img', {
    staticClass: "mr-3",
    attrs: {
      "src": _vm.profileImage,
      "width": "100px",
      "alt": ""
    }
  }) : _c('img', {
    attrs: {
      "src": "/img/profile.png",
      "width": "100px",
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "profile-detail"
  }, [_c('h5', {
    staticClass: "mt-2 font-16"
  }, [_vm._v(" " + _vm._s(_vm.fullName) + " ")]), _vm.userPhone ? _c('p', {
    staticClass: "my-2 phoneNumberPara"
  }, [_c('b-icon', {
    attrs: {
      "icon": "telephone-fill",
      "aria-label": "Help"
    }
  }), _c('span', {
    staticClass: "ml-1 mb-2"
  }, [_vm._v(" " + _vm._s(_vm.userPhone))])], 1) : _vm._e(), _vm.defaultAddress && Object.keys(_vm.defaultAddress).length > 0 ? _c('p', {
    staticClass: "mb-2 phoneNumberPara"
  }, [_c('b-icon', {
    attrs: {
      "icon": "geo-alt-fill",
      "aria-label": "Help"
    }
  }), _vm._v(" " + _vm._s(_vm.defaultAddress.street2) + ", " + _vm._s(_vm.defaultAddress.city) + ", " + _vm._s(_vm.defaultAddress.state) + ", " + _vm._s(_vm.defaultAddress.zip) + " ")], 1) : _vm._e()]), _vm.editKey ? _c('div', {
    staticClass: "edit-icon margin-left"
  }, [_c('a', {
    staticClass: "d-flex text-dark",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.goToEdit
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "pencil-fill",
      "aria-label": "Help"
    }
  }), _vm._v(" " + _vm._s(_vm.$t("edit")) + " ")], 1)]) : _vm._e()])])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }